<template>
	<mu-appbar title="导航栏"></mu-appbar>
</template>
<script>
export default {
    name: 'appbar',
    // render() {
    // 	console.log(this.$compile(`<h1></h1>`).render)
    //     return this.$compile(`<h1></h1>`).render
    // },
    // staticRenderFns(){
    // 	return this.$compile(`<h1></h1>`).staticRenderFns
    // }
}
</script>



// WEBPACK FOOTER //
// appbar.vue?b2377f10